var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height my-0 px-5",attrs:{"align":"start"}},[_c('v-col',[_c('circle-integration-list',{attrs:{"integrations":_vm.availableIntegrations}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }